import {Injectable} from '@angular/core';
import {merge, Observable} from 'rxjs';
import {share, takeUntil, tap} from 'rxjs/operators';
import {destroy$} from '../../destroyable';
import {SessionService} from '../api-2/session.service';

export enum DeliverableListingStatus {
    active = 'active'
}

export interface DexDirectDeliverable {
    classification: unknown;
    classification_code: string;
    decimal_places: string;
    deliverable_id: string;
    identifier: string;
    listing_status: DeliverableListingStatus;
    symbol: string;
    tags: unknown[];
}

@Injectable()
export class DexApiDraftDbService {

    public readonly connection$: Observable<unknown>;

    public readonly trancheById = new Map<string, any>();

    public readonly deliverableById = new Map<DexDirectDeliverable['deliverable_id'], DexDirectDeliverable>();

    public readonly tradableById = new Map<string, any>();

    /**
     * trancheId, deliverableId, ruleName, value
     */
    public readonly trancheDeliverableRulesMap = new Map<string, Map<DexDirectDeliverable['deliverable_id'], Map<string, any>>>();

    private readonly destroy$ = destroy$();

    private readonly wsMsgStore = new Map<string, any[]>();

    constructor(
        private sessionService: SessionService
    ) {
        this.connection$ = this.createSharedConnectionStream();

        (window as any).dexDb = this; // TODO
    }

    private connectDexApi(): Observable<unknown> {
        return new Observable(observer => {
            const session = this.sessionService.createSimpleSession(
                'ws://176.58.125.11:12422',
                'data_aggregator_2',
                'f8afdeddab4d1da74349d0f058837bd5'
            );

            const sessionSubscription = merge(
                session.onOpen$,
                session.onClose$,
                session.onError$,
                session.onMessage$.pipe(
                    tap(e => this.storeDexApiWsMessage(e))
                ),
                session.onCatchup$
            ).subscribe(observer);

            return () => {
                console.warn('unsub'); // TODO
                session.close();
                sessionSubscription.unsubscribe();

                this.trancheById.clear();
                this.deliverableById.clear();
                this.tradableById.clear();
                this.trancheDeliverableRulesMap.clear();
            };
        });
    }

    private storeDexApiWsMessage(e: {ses: any, msg: Record<string, any>}): void {
        Object.keys(e.msg).forEach(key => {
            const value = e.msg[key];
            let rec = this.wsMsgStore.get(key);

            if (rec) {
                if (rec.length >= 1000) {
                    rec.shift();
                }

                rec.push(value);
            } else {
                rec = [value];
                this.wsMsgStore.set(key, rec);
            }

            switch (key) {
                case 'deliverable': {
                    const deliverable = value as DexDirectDeliverable;
                    this.deliverableById.set(deliverable.deliverable_id, deliverable);
                    break;
                }
            }
        });
    }

    private createSharedConnectionStream(): Observable<unknown> {
        return this.connectDexApi().pipe(
            takeUntil(this.destroy$),
            share()
        );
    }

}
